function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex';
import { helpCenterApi, templatePayCode, templateViewApi, templateExportApi } from '@/api/user';
import file from '@/utils/file';
import Vue from 'vue';
Vue.use(file);
import { roterPre } from '@/settings';
import payment from '@/components/form-common/dialog-payment';
export default {
  name: 'CrmebOaEntIndex',
  components: {
    payment: payment
  },
  data: function data() {
    return {
      keyword: '',
      activeName: '',
      loading: false,
      labelText: '全部',
      listloading: false,
      dataList: [],
      payData: {},
      page: 1,
      limit: 15,
      noticeNav: [{
        val: '',
        name: '全部'
      }, {
        val: 'document',
        name: '操作手册'
      }, {
        val: 'article',
        name: '知识社区'
      }
      // {
      //   val: 'file',
      //   name: '模板文库'
      // }
      ]
    };
  },
  mounted: function mounted() {
    if (this.$route.params.index) {
      this.activeName = this.$route.params.index;
    } else {
      this.activeName = '';
    }
    this.keyword = this.$route.query.keyword;
    this.getList();
    window.addEventListener('scroll', this.lazyLoading);
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.lazyLoading);
  },
  watch: {
    $route: function $route(val, from) {
      this.keyword = val.query.keyword;
      this.getList();
    }
  },
  computed: {},
  methods: _objectSpread(_objectSpread({
    handleClick: function handleClick(e) {
      this.labelText = e.label;
      this.getList();
    }
  }, mapMutations('user', ['SET_MENU_LIST'])), {}, {
    // 滚动加载
    lazyLoading: function lazyLoading(e) {
      var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      var clientHeight = document.documentElement.clientHeight;
      var scrollHeight = document.documentElement.scrollHeight;
      var bottomOfWindow = scrollTop + clientHeight >= scrollHeight - 4;
      if (bottomOfWindow && this.dataList.length > 5) {
        this.page = this.page + 1;
        this.getList(1);
      } else {}
    },
    // 预览
    proview: function proview(item) {
      var _this = this;
      templateViewApi(item.id).then(function (res) {
        if (res.status == 200) {
          var url = "".concat(roterPre, "/openFile?id=").concat(item.id, "&&fid=").concat(item.pid || _this.spaceId);
          window.open(url, '_blank');
        }
      });
    },
    // 打开知识社区
    openArticle: function openArticle(item) {
      this.$router.push({
        path: "".concat(roterPre, "/user/forum/index"),
        query: {
          id: item.id
        }
      });
    },
    // 打开帮助中心
    openHelp: function openHelp(item) {
      window.open("https://doc.tuoluojiang.com/doc/own/".concat(item.id), '_blank');
    },
    fileDown: function fileDown(item) {
      var _this2 = this;
      templateExportApi(item.id).then(function (res) {
        _this2.fileLinkDownLoad(res.data.url, '模板文库');
      }).catch(function (err) {
        _this2.handlePayment(item.id);
      });
    },
    handlePayment: function handlePayment(id) {
      var _this3 = this;
      templatePayCode(id).then(function (res) {
        _this3.payData = {
          title: '支付',
          width: '300px',
          type: 0,
          data: res.data
        };
        _this3.$refs.payment.handleOpen();
      });
    },
    getList: function getList(val) {
      var _this4 = this;
      this.$store.commit('app/SET_CLICK_KEY', this.keyword);
      this.loading = true;
      if (this.activeName == 'all') {
        this.activeName = '';
      }
      if (!val) {
        this.page = 1;
      }
      this.listloading = true;
      var data = {
        word: this.keyword,
        type: this.activeName,
        page: this.page,
        limit: this.limit
      };
      helpCenterApi(data).then(function (res) {
        _this4.loading = false;
        if (val == 1) {
          _this4.dataList = [].concat(_toConsumableArray(_this4.dataList), _toConsumableArray(res.data));
          _this4.listloading = false;
        } else {
          _this4.dataList = res.data;
        }
      });
    }
  })
};